import React from 'react'
import Typography from '@components/std-components/Typography'
import MdcKeyboardBackspace from '@meronex/icons/mdc/MdcKeyboardBackspace'
import * as css from './BackToOrders.css'
import { stores } from '@stores'
import { useTranslation } from 'react-i18next'
import { ENHANCED_VIEW_ROUTES } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'

const BackToOrder: React.FC<any> = () => {
  const {
    nav: {
      queryParams: { clientId, buyingSessionGroupId, clientType }
    },
    showroomSidebarStore: { redirectToPage },
    productConfiguration: { enhancedViewEnabled }
  } = stores
  const { t } = useTranslation()
  return (
    <div
      className={css.backToOrdersContainer}
      onClick={() => {
        const path = `/showroom/clients/buyingSessionGroup/${
          enhancedViewEnabled ? ENHANCED_VIEW_ROUTES.basketAndOrders : 'basketAndOrders'
        }`
        redirectToPage(path, {
          clientId,
          buyingSessionGroupId,
          clientType
        })
      }}
    >
      <MdcKeyboardBackspace size={18} className={css['arrow-back']} />
      <Typography variant={'lookTitle'} color={'primary'}>
        {t('common.label.back', 'back')}
      </Typography>
    </div>
  )
}

export default BackToOrder
